<template>
  <order-form
    v-model="form"
    :workers="workers"
    :categories="categories"
    :statuses="statuses"
    :clients="clients"
    class="max-w-3xl bg-white"
    @submit="submit"
  >
    <div
      class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-8 py-4"
    >
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
      >
        Создать Заявку
      </loading-button>
    </div>
  </order-form>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton.vue';
import OrderForm from './Form.vue';
import serializePhotos from '@/Shared/serializePhotos';
import omit from 'lodash/omit';

export default {
  components: {
    LoadingButton,
    OrderForm,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    clients: {
      type: Array,
      required: true,
    },
    statuses: {
      type: Array,
      required: true,
    },
    workers: {
      type: Array,
      required: true,
    },
  },
  remember: 'form',
  emits: ['success'],
  data() {
    return {
      form: this.$inertia.form({
        order: omit(this.order, 'id', 'deleted_at'),
      }),
    };
  },
  methods: {
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          order: { ...data.order, photos: serializePhotos(data.order.photos) },
        }))
        .post(this.$routes.create_order_client(this.order.client_id), {
          preserveState: (page) =>
            page.props.errors && Object.keys(page.props.errors).length,
          preserveScroll: (page) =>
            page.props.errors && Object.keys(page.props.errors).length,
          onSuccess: () => {
            this.$emit('success');
            this.form.reset('order');
          },
        });
    },
  },
};
</script>
